import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";

import Dashboard from "./components/Dashboard";
import Main from "./components/Main";
import StudentDashboard from "./components/Students/StudentDashboard";
import AddStudent from "./components/Students/AddStudent";
import EditStudent from "./components/Students/EditStudent";
import AnnualTasksDashboard from "./components/AnnualTasks/AnnualTasksDashboard";
import AddSessions from "./components/AnnualTasks/AddSessions";
import Login from "./components/Login/Login";
import ParentSelectChildren from "./components/Login/ParentSelectChildren";
import ManageSessions from "./components/AnnualTasks/ManageSessions";
import EditSession from "./components/AnnualTasks/EditSession";
import SecurityDashboard from "./components/Security/SecurityDashboard";
import AddNewUser from "./components/Security/AddNewUser";
import GroupManagement from "./components/Security/GroupManagement";
import ManageUsers from "./components/Security/ManageUsers";
import EditUser from "./components/Security/EditUser";
import AddGroup from "./components/Security/AddGroup";
import EditGroup from "./components/Security/EditGroup";
import RightsAssignment from "./components/Security/RightsAssignment";
import ChangePassword from "./components/Security/ChangePassword";
import SetupDashboard from "./components/Setup/SetupDashboard";
import NoAccess from "./components/General/NoAccess";

import ManageBankAccounts from "./components/Setup/ManageBankAccounts";
import ManageConcession from "./components/Setup/ManageConcession";
import ManageSection from "./components/Setup/ManageSection";
import ManageWings from "./components/Setup/ManageWings";
import ManageClasses from "./components/Setup/ManageClasses";
import ManageClassSyllabus from "./components/Setup/ManageClassSyllabus";
import ClassSyllabusFiles from "./components/Setup/ClassSyllabusFiles";
import ManageFeeTypes from "./components/Setup/ManageFeeTypes";
import SchoolInfo from "./components/Setup/SchoolInfo";
import AddWings from "./components/Setup/AddWings";
import AddClass from "./components/Setup/AddClass";
import AddFeeType from "./components/Setup/AddFeeType";
import AddStudentHouse from "./components/Setup/AddStudentHouse";
import ManageStudentHouses from "./components/Setup/ManageStudentHouses";
import EditStudentHouse from "./components/Setup/EditStudentHouse";
import AddBankAcc from "./components/Setup/AddBankAcc";
import AddSection from "./components/Setup/AddSection";
import EditFeeType from "./components/Setup/EditFeeType";
import EditConcession from "./components/Setup/EditConcession";
import AddConcession from "./components/Setup/AddConcession";
import PrintAttendenceSheet from "./components/Setup/PrintAttendenceSheet";
import EditBankAcc from "./components/Setup/EditBankAcc";
import PrintTestPerforma from "./components/Setup/PrintTestPerforma";
import PrintStudentCards from "./components/Setup/PrintStudentCards";

import PayrollDashboard from "./components/PayRoll/PayrollDashboard";
import ManageEmployee from "./components/PayRoll/ManageEmployee";
import EditWings from "./components/Setup/EditWings";
import Absenteelist from "./components/Setup/Absenteelist";
import ManageDesignations from "./components/PayRoll/ManageDesignations";
import LibraryDashboard from "./components/Library/LibraryDashboard";
import AddBook from "./components/Library/AddBook";
import ViewLibrary from "./components/Library/ViewLibrary";
import SearchStudents from "./components/Students/SearchStudents";
import EditClass from "./components/Setup/EditClass";
import PrintBioDataForms from "./components/Setup/PrintBioDataForms";
import FeeSystemDashboard from "./components/FeeSystem/FeeSystemDashboard";
import ScrollDifferenceDetail from "./components/FeeSystem/ScrollDifferenceDetail";
import StruckoffList from "./components/Reports/StruckoffList";
import ReportDashboard from "./components/Reports/ReportDashboard";
import AccountHeadwiseReport from "./components/Reports/AccountHeadwiseReport";

import ConcessionReport from "./components/Reports/ConcessionReport";
import DefaultersList from "./components/Reports/DefaultersList";
import FeeCollectionDetail from "./components/Reports/FeeCollectionDetail";
import FeeReporting from "./components/Reports/FeeReporting";
import NewAdmittedUnPaid from "./components/Reports/NewAdmittedUnPaid";
import StatusWiseChange from "./components/Reports/StatusWiseChange";
import StruckedStudents from "./components/Reports/StruckedStudents";
import SectionWiseList from "./components/Reports/SectionWiseList";

import SectionWiseClassList from "./components/PrintReports/SectionWiseClassList";
import Classwiseattendancesheet from "./components/PrintReports/Classwiseattendancesheet";
import AbsentListClassWise from "./components/PrintReports/AbsentListClassWise";
import PrintStudentCardsList from "./components/PrintReports/PrintStudentCardsList";
import PrintTestPerformaList from "./components/PrintReports/PrintTestPerformaList";
import PrintBioDataFormsList from "./components/PrintReports/PrintBioDataFormsList";
import PrintOralAssessmentReport1 from "./components/PrintReports/PrintOralAssessmentReport1";
import PrintOralAssessmentReport1Urdu from "./components/PrintReports/PrintOralAssessmentReport1Urdu";
import PrintOralAssessmentReport2Urdu from "./components/PrintReports/PrintOralAssessmentReport2Urdu";

import StudentFineReport from "./components/Reports/StudentFineReport";
import StudentStrengthReport from "./components/Reports/StudentStrengthReport";
import UnpaidStudent from "./components/Reports/UnpaidStudent";
import MonthlyTasksDashboard from "./components/MonthlyTasks/MonthlyTasksDashboard";
import ManageMonth from "./components/MonthlyTasks/ManageMonth";
import ManageMonthlyVouchers from "./components/MonthlyTasks/ManageVouchers";
import StartNewMonth from "./components/MonthlyTasks/StartNewMonth";
import AccountsDashboard from "./components/Accounts/AccountsDashboard";
import ManageAccount from "./components/Accounts/ManageAccount";
import CertificateDashboard from "./components/Certificate/CertificateDashboard";
import PrintCertificates from "./components/Certificate/PrintCertificates";
import ExaminationDashboard from "./components/ExaminationSystem/ExaminationDashboard";
import AddExaminations from "./components/ExaminationSystem/AddExaminations";
import AddSubject from "./components/ExaminationSystem/AddSubject";
import AddSubjectType from "./components/ExaminationSystem/AddSubjectType";
import CloseExam from "./components/ExaminationSystem/CloseExam";
import DataEntry from "./components/ExaminationSystem/DataEntry";
import ExamDataEntryOptions from "./components/ExaminationSystem/ExamDataEntryOptions";
import ExamDataSheetOptions from "./components/ExaminationSystem/ExamDataSheetOptions";
import ManageClassSubjects from "./components/ExaminationSystem/ManageClassSubjects";
import ManageExamClasses from "./components/ExaminationSystem/ManageExamClasses";
import ManageExaminations from "./components/ExaminationSystem/ManageExaminations";
import ManageSubjects from "./components/ExaminationSystem/ManageSubjects";
import ManageSubjectTypes from "./components/ExaminationSystem/ManageSubjectTypes";
import OldResults from "./components/ExaminationSystem/OldResults";
import AdmitStudent from "./components/Students/AdmitStudent";
import StocksDashboard from "./components/StockManagement/StocksDashboard";
import AddStockCategory from "./components/StockManagement/AddStockCategory";
import IssueItems from "./components/StockManagement/IssueItems";
import ManageStockCategory from "./components/StockManagement/ManageStockCategory";
import StockDetail from "./components/StockManagement/StockDetail";
import EditSubjectType from "./components/ExaminationSystem/EditSubjectType";
import NewStudentList from "./components/Students/NewStudentList";
import ChangeRegistrationNo from "./components/Students/ChangeRegistrationNo";
import PrintVouchers from "./components/FeeSystem/PrintVouchers";
import StudentsMissingVoucher from "./components/FeeSystem/StudentsMissingVoucher";
import EditChallan from "./components/FeeSystem/EditChallan";
import AdminEditChallan from "./components/FeeSystem/AdminEditChallan";
import GenerateChallan from "./components/FeeSystem/GenerateChallan";
import GenerateAdvanceChallan from "./components/FeeSystem/GenerateAdvanceChallan";
import DuplicatePaymentReceived from "./components/FeeSystem/DuplicatePaymentReceived";
import ChallanCorrector from "./components/FeeSystem/ChallanCorrector";
import StaffAttendanceDashboard from "./components/StaffAttendance/StaffAttendanceDashboard";
import MarkAttendance from "./components/StaffAttendance/MarkAttendance";
import AttendanceSummary from "./components/StaffAttendance/AttendanceSummary";
import LeaveRegister from "./components/StaffAttendance/LeaveRegister";
import AttendanceRights from "./components/StaffAttendance/AttendanceRights";
import EditSubject from "./components/ExaminationSystem/EditSubject";
import EditExam from "./components/ExaminationSystem/EditExam";
import ManageEmployeeTypes from "./components/PayRoll/ManageEmployeeTypes";
import AddEmployeeType from "./components/PayRoll/AddEmployeeType";
import ChangeYear from "./components/Accounts/ChangeYear";
import AddNewAccount from "./components/Accounts/AddNewAccount";
import ManageVouchers from "./components/Accounts/ManageVouchers";
import RPTAwardList from "./components/PrintReports/RPTAwardList";
import RPTAwardListClass from "./components/PrintReports/RPTAwardListClass";
import OpeningBalances from "./components/Accounts/OpeningBalances";
import ManageOpeningBalances from "./components/Accounts/ManageOpeningBalances";
import AddVoucher from "./components/Accounts/AddVoucher";
import TrialBalanceLevelWise from "./components/Accounts/TrialBalanceLevelWise";
import TrialBalanceHeadWise from "./components/Accounts/TrialBalanceHeadWise";
import BudgetHeadWise from "./components/Accounts/BudgetHeadWise";
import PrintBudgetHeadWise from "./components/Accounts/PrintBudgetHeadWise";
import PrintReceiptPayment from "./components/Accounts/PrintReceiptPayment";
import AddSalary from "./components/PayRoll/AddSalary";
import BankSalalryList from "./components/PayRoll/BankSalalryList";
import CreateSalary from "./components/PayRoll/CreateSalary";
import GenerateEmployeesSalary from "./components/PayRoll/GenerateEmployeesSalary";
import BulkSalaryUpdate from "./components/PayRoll/BulkSalaryUpdate";
import ManageSalaryTypes from "./components/PayRoll/ManageSalaryTypes";
import IncreaseDecreaseSalary from "./components/PayRoll/IncreaseDecreaseSalary";
import UpdateSection from "./components/Setup/UpdateSection";
import EditOpeningBalance from "./components/Accounts/EditOpeningBalance";
import AddSalaryType from "./components/PayRoll/AddSalaryType";
import EditSalaryType from "./components/PayRoll/EditSalaryType";
import ManagePayRates from "./components/PayRoll/ManagePayRates";
import ManagePayRateDetails from "./components/PayRoll/ManagePayRateDetails";
import AddPayRate from "./components/PayRoll/AddPayRate";
import EditPayRate from "./components/PayRoll/EditPayRate";
import EditEmployeeType from "./components/PayRoll/EditEmployeeType";
import ManageLoanDeduction from "./components/PayRoll/ManageLoanDeduction";
import AddLoanDeduction from "./components/PayRoll/AddLoanDeduction";
import EditLoanDeduction from "./components/PayRoll/EditLoanDeduction";
import AddOtherDeduction from "./components/PayRoll/AddOtherDeduction";
import ManageOtherLoanDeductions from "./components/PayRoll/ManageOtherLoanDeductions";
import EditOtherLoanDeduction from "./components/PayRoll/EditOtherLoanDeduction";
import EmployeeLedger from "./components/PayRoll/EmployeeLedger";
import AddBankScroll from "./components/FeeSystem/AddBankScroll";
import ChangeScrollDate from "./components/FeeSystem/ChangeScrollDate";
import AdvanceSearch from "./components/Students/AdvanceSearch";
import StudentNotifications from "./components/Students/StudentNotifications";
import TimeTableManagement from "./components/Students/TimeTableManagement";
import TimeTableCoverage from "./components/TimeTable/TimeTableCoverage";
import TimeTableTeacherWise from "./components/TimeTable/TimeTableTeacherWise";
import SchoolEventsManagement from "./components/SchoolEvents/SchoolEventsManagement";
import AddNewEmployee from "./components/PayRoll/AddNewEmployee";

import StudentLedger from "./components/Students/StudentLedger";
import StudentLedger2 from "./components/Students/StudentLedger2";
import PrintStudentLedger from "./components/Students/PrintStudentLedger";
import PrintChallan from "./components/FeeSystem/PrintChallan";
import PublicChallanDownload from "./components/FeeSystem/PublicChallanDownload";
import CollectionReport from "./components/FeeSystem/CollectionReport";
import CollectionReportHeadWise from "./components/FeeSystem/CollectionReportHeadWise";
import DateWiseCollectionReport from "./components/FeeSystem/DateWiseCollectionReport";
import AdvanceAmountReport from "./components/FeeSystem/AdvanceAmountReport";
import AdvanceAdjustedInMonthReport from "./components/FeeSystem/AdvanceAdjustedInMonthReport";
import AddAbsentFine from "./components/FeeSystem/AddAbsentFine";
import AddOtherDuesFine from "./components/FeeSystem/AddOtherDuesFine";
import MarkAsStudyComplete from "./components/AnnualTasks/MarkAsStudyComplete";
import PromoteClasses from "./components/AnnualTasks/PromoteClasses";
import BiodataLists from "./components/Students/BiodataLists";
import ChangeStudentStatus from "./components/FeeSystem/ChangeStudentStatus";
import AddClassesInSessions from "./components/AnnualTasks/AddClassesInSessions";
import SMSAlertDashboard from "./components/SMSAlert/SMSAlertDashboard";
import NewlyAdmittedStudents from "./components/Reports/NewlyAdmittedStudents";
import ManageSalary from "./components/PayRoll/ManageSalary";
import AttendenceSummary from "./components/Reports/AttendenceSummary";
import EditEmployee from "./components/PayRoll/EditEmployee";
import EmployeeHistory from "./components/PayRoll/EmployeeHistory";
import PaySlipPrint from "./components/PayRoll/PaySlipPrint";
import PaySlips from "./components/PayRoll/PaySlips";
import EmployeeReports from "./components/PayRoll/EmployeeReports";
import ZeroReports from "./components/PayRoll/ZeroReports";
import SummarySheet from "./components/PayRoll/SummarySheet";
import ChangeStatus from "./components/PayRoll/ChangeStatus";
import PrintAttendanceSummary from "./components/StaffAttendance/PrintAttendanceSummary";
import PrintStAttendanceSummary from "./components/Reports/PrintStAttendanceSummary";
import PrintSummarySheet from "./components/PayRoll/PrintSummarySheet";
import PrintSummarySheetTwo from "./components/PayRoll/PrintSummarySheetTwo";
import ManageLeaves from "./components/PayRoll/ManageLeaves";
import AddArrear from "./components/PayRoll/AddArrear";
import PrintEOBIList from "./components/PayRoll/Prints/PrintEOBIList";
import PrintCollectionReport from "./components/FeeSystem/PrintCollectionReport";
import PrintSWFList from "./components/PayRoll/Prints/PrintSWFList";
import PrintTaxList from "./components/PayRoll/Prints/PrintTaxList";
import PrintStaffList1 from "./components/PayRoll/Prints/PrintStaffList1";
import PrintStaffList2 from "./components/PayRoll/Prints/PrintStaffList2";
import PrintStaffList3 from "./components/PayRoll/Prints/PrintStaffList3";
import PrintTaxList1 from "./components/PayRoll/Prints/PrintTaxList1";
import PrintStaffList4 from "./components/PayRoll/Prints/PrintStaffList4";
import PrintBankSalalryList from "./components/PayRoll/Prints/PrintBankSalalryList";
import PrintMarkedAttendance from "./components/StaffAttendance/PrintMarkedAttendance";
import EditStockItems from "./components/StockManagement/EditStockItems";
import DefaultersListReport from "./components/Reports/DefaultersListReport";
import ExamClasses from "./components/ExaminationSystem/ExamClasses";
import OtherLoanDeductionsPrint from "./components/PayRoll/OtherLoanDeductionsPrint";
import LoanDeductionsPrint from "./components/PayRoll/LoanDeductionsPrint";
import UnpaidStudentPrint from "./components/Reports/UnpaidStudentPrint";
import ConcessionPrint from "./components/Reports/ConcessionPrint";
import StatusWisePrint from "./components/Reports/StatusWisePrint";
import StudentFinePrint from "./components/Reports/StudentFinePrint";
import StAttendenceSummary from "./components/Reports/StAttendenceSummary";
import ReportsMenu from "./components/Reports/ReportsMenu";

import AddLeave from "./components/PayRoll/AddLeave";
import PrintLeaveRegister from "./components/StaffAttendance/PrintLeaveRegister";
import PrintStudentCertificates from "./components/Certificate/PrintStudentCertificates";
import StudentAttendanceDashboard from "./components/StudentAttendance/StudentAttendanceDashboard";
import MarkSTAttendance from "./components/StudentAttendance/MarkSTAttendance";
import StudentForm from "./components/Shared/StudentForm";
import AttendanceSTSummary from "./components/StudentAttendance/AttendanceSTSummary";
import StockItemsPrint from "./components/StockManagement/StockItemsPrint";
import SendAlertToStaff from "./components/SMSAlert/SendAlertToStaff";
import EditVoucher from "./components/Accounts/EditVoucher";
import SendtoSinglePerson from "./components/SMSAlert/SendtoSinglePerson";
import SendAlertToParents from "./components/SMSAlert/SendAlertToParents";

import ReceiptPayment from "./components/Accounts/ReceiptPayment";
import BioDataForms from "./components/Shared/BioDataForms";
import StudentHistory from "./components/Students/StudentHistory";
import PrintBiodataLists from "./components/Students/PrintBiodataLists";
import StudentCard from "./components/Shared/StudentCard";
import PrintNewAdmittedUnPaid from "./components/Reports/PrintNewAdmittedUnPaid";
import PrintAttendenceSheetClassWise from "./components/Setup/PrintAttendenceSheetClassWise";
import PrintBiodataLists1 from "./components/Students/PrintBiodataLists1";
import PrintVouchersWebsite from "./components/FeeSystem/PrintVouchersWebsite";
import PrintZeroReport from "./components/PayRoll/PrintZeroReport";
import FeeReportingPrint from "./components/Reports/FeeReportingPrint";
import PrintBioDataFormsforSection from "./components/Setup/PrintBioDataFormsforSection";
import PrintManageLeaves from "./components/PayRoll/Prints/PrintManageLeaves";
import PrintStockDetail from "./components/StockManagement/PrintStockDetail";
import EditDesignation from "./components/PayRoll/EditDesignation";
import AttendanceReport from "./components/StaffAttendance/AttendanceReport";
import PrintAttendanceReport from "./components/StaffAttendance/PrintAttendanceReport";
import AddNewDesignation from "./components/PayRoll/AddNewDesignation";
import PrintCollectionReportDetail from "./components/FeeSystem/PrintCollectionReportDetail";
import SalaryTypeValues from "./components/PayRoll/SalaryTypeValues";

import TeacherMain from "./components/Teacher/TeacherMain";
import TeacherDashboard from "./components/Teacher/TeacherDashboard";
import ManageSections from "./components/Teacher/ManageSections";
import WingHeadManageSections from "./components/Teacher/WingHeadManageSections";
import TeacherWingSectionSettings from "./components/Teacher/TeacherWingSectionSettings";
import TeacherLogin from "./components/Teacher/TeacherLogin";
import MarkStudentAttendance from "./components/Teacher/MarkStudentAttendance";
import ATSummary from "./components/Teacher/ATSummary";
import UpdateProfile from "./components/Teacher/UpdateProfile";
import Change_Password from "./components/Teacher/Change_Password";
import UpdatePhoto from "./components/Teacher/UpdatePhoto";
import Section_Incharge from "./components/Teacher/Section_Incharge";
import Subject_Teacher from "./components/Teacher/Subject_Teacher";
import PrintAllVouchers from "./components/FeeSystem/PrintAllVouchers";
import DeletedVouchers from "./components/FeeSystem/DeletedVouchers";
import PrintConcessionsRules from "./components/Setup/PrintConcessionsRules";
import PrintConcessionStudents from "./components/Setup/PrintConcessionStudents";
import PrintManageClasses from "./components/Setup/PrintManageClasses";
import PrintManageSections from "./components/Setup/PrintManageSections";
import PrintFeeTypeList from "./components/Setup/PrintFeeTypeList";
import PrintManageWings from "./components/Setup/PrintManageWings";
import IssueBook from "./components/Library/IssueBook";
import EditBook from "./components/Library/EditBook";
import MonthDetails from "./components/MonthlyTasks/MonthDetails";
import PrintMonthDetails from "./components/MonthlyTasks/PrintMonthDetails";
import PrintExamDataEntryOptions from "./components/ExaminationSystem/PrintExamDataEntryOptions";
import ExamDataSO from "./components/ExaminationSystem/ExamDataSO";
import CloseThisExam from "./components/ExaminationSystem/CloseThisExam";
import PrintExamDataSheet from "./components/ExaminationSystem/PrintExamDataSheet";
import PrintExamDataSheetMultiple from "./components/ExaminationSystem/PrintExamDataSheetMultiple";
import PrintResultCards from "./components/ExaminationSystem/PrintResultCards";
import ManageResultCards from "./components/ExaminationSystem/ManageResultCards";
import AddResultCard from "./components/ExaminationSystem/AddResultCard";
import EditResultCard from "./components/ExaminationSystem/EditResultCard";
import PublishResultCard from "./components/ExaminationSystem/PublishResultCard";
import PrintPublishedResultCard from "./components/ExaminationSystem/PrintPublishedResultCard";
import PrintPublishedStudentResultCards from "./components/ExaminationSystem/PrintPublishedStudentResultCards";
import PrintPublishedResultCardList from "./components/ExaminationSystem/PrintPublishedResultCardList";
import PrintMasterSheet from "./components/ExaminationSystem/PrintMasterSheet";
import PrintComponentMarksSheet from "./components/ExaminationSystem/PrintComponentMarksSheet";
import PrintMarksCriteria from "./components/ExaminationSystem/PrintMarksCriteria";
import ExaminationGuidelines from "./components/ExaminationSystem/ExaminationGuidelines";
import OralAssessmentReport1 from "./components/Setup/OralAssessmentReport1";
import OralAssessmentReport2 from "./components/Setup/OralAssessmentReport2";
import PrintAdvaceSearchReport from "./components/Students/PrintAdvaceSearchReport";
import PrintNewlyAdmittedStudents from "./components/Students/PrintNewlyAdmittedStudent";
import StudentProfileSearch from "./components/Students/StudentProfileSearch";
import PrintStudentProfile from "./components/Students/PrintStudentProfile";

import NewTicket from "./components/Support/NewTicket";
import SupportOpen from "./components/Support/Open";
import SupportInbox from "./components/Support/Inbox";
import TicketsClose from "./components/Support/TicketsClose";
import TicketsDetail from "./components/Support/TicketsDetail";
import InboxCounter from "./components/Support/InboxCounter";
import ManageTicketTypes from "./components/Support/ManageTicketTypes";
import AddTicketType from "./components/Support/AddTicketType";
import EditTicketType from "./components/Support/EditTicketType";
import PublicSupportTicket from "./components/Support/PublicSupportTicket";
import StudentSupportNewTicket from "./components/StudentPanel/StudentSupportNewTicket";
import StudentSupportTickets from "./components/StudentPanel/StudentSupportTickets";
import StudentSupportTicketDetail from "./components/StudentPanel/StudentSupportTicketDetail";

//  IQRA

import IssuanceReport from "./components/Library/IssuanceReport";
import ReturnReport from "./components/Library/ReturnReport";
import PrintIssuanceReport from "./components/Library/PrintIssuanceReport";
import PrintReturnReport from "./components/Library/PrintReturnReport";
import PrintViewLibrary from "./components/Library/PrintViewLibrary";
import OverdueReport from "./components/Library/OverdueReport";
import BorrowHistory from "./components/Library/BorrowHistory";
import ImportBooks from "./components/Library/ImportBooks";
import ManageSettings from "./components/Setup/ManageSettings";
import EditSettings from "./components/Setup/EditSettings";
import AddSettings from "./components/Setup/AddSettings";
import GeneralLedger from "./components/Accounts/GeneralLedger";
import PrintDetailSummarySheet from "./components/PayRoll/PrintDetailSummarySheet";
import PrintOpeningBalance from "./components/Accounts/PrintOpeningBalance";
import PrintManageAccount from "./components/Accounts/PrintManageAccount";
import PrintTrialBalanceLevelWise from "./components/Accounts/PrintTrialBalanceLevelWise";
import PrintTrialBalanceHeadWise from "./components/Accounts/PrintTrialBalanceHeadWise";
import PrintIncomeExpenditure from "./components/Accounts/PrintIncomeExpenditure";
import PrintGeneralLedger from "./components/Accounts/PrintGeneralLedger";

import PrintStudentStrengthReports from "./components/Reports/PrintStudentStrengthReports";

import StudentPanelDashboard from "./components/StudentPanel/StudentPanelDashboard";
import StudentMain from "./components/StudentPanel/Main";
import Student_Change_Password from "./components/StudentPanel/Student_Change_Password";
import Parent_Change_Password from "./components/StudentPanel/Parent_Change_Password";
import StudentUpdatePhoto from "./components/StudentPanel/StudentUpdatePhoto";
import StudentUpdateProfile from "./components/StudentPanel/StudentUpdateProfile";
import StudentPanelLedger from "./components/StudentPanel/StudentLedger";
import SingleStudentSummary from "./components/StudentPanel/SingleStudentSummary";
import ExamResultsComingSoon from "./components/StudentPanel/ExamResultsComingSoon";
import StudentPanelModuleComingSoon from "./components/StudentPanel/StudentPanelModuleComingSoon";
import ViewSiblings from "./components/StudentPanel/ViewSiblings";
import StudentPanelTransport from "./components/StudentPanel/StudentPanelTransport";
import StudentPanelAlerts from "./components/StudentPanel/StudentPanelAlerts";
import StudentPanelEvents from "./components/StudentPanel/StudentPanelEvents";
import StudentPanelClassTimeTable from "./components/StudentPanel/StudentPanelClassTimeTable";
import StudentPanelSyllabusDownload from "./components/StudentPanel/StudentPanelSyllabusDownload";
import StudentPanelDiary from "./components/StudentPanel/StudentPanelDiary";
import StudentPanelLibrary from "./components/StudentPanel/StudentPanelLibrary";
import IncomeExpenditure from "./components/Accounts/IncomeExpenditure";
import ViewPaySlips from "./components/Teacher/ViewPaySlips";
import TeacherEvents from "./components/Teacher/TeacherEvents";
import TeacherTimeTable from "./components/Teacher/TeacherTimeTable";
import TeacherDiaryManager from "./components/Teacher/TeacherDiaryManager";
import EditRuleApplicable from "./components/Setup/EditRuleApplicable";

import PrintManageUser from "./components/Security/PrintManageUser";
import PrintRuleApplicable from "./components/Setup/PrintRuleApplicable";
import AppointmentLetter from "./components/PayRoll/AppointmentLetter";
import AppointmentLetterPrint from "./components/PayRoll/AppointmentLetterPrint";
import FeePostingIssues from "./components/Reports/FeePostingIssues";
import PrintPessiList from "./components/PayRoll/Prints/PrintPessiList";
import PrintTransportList from "./components/PayRoll/Prints/PrintTransportList";
import ImportStudent from "./components/Students/ImportStudent";
import StartNewMonth2 from "./components/MonthlyTasks/StartNewMonth2";
import RoutesReport from "./components/Transport/RoutesReport";
import RoutesPrint from "./components/Transport/RoutesPrint";
import TransportDashboard from "./components/Transport/TransportDashboard";
import ManageBusRoutes from "./components/Transport/ManageBusRoutes";
import AddBusRoutes from "./components/Transport/AddBusRoutes";
import EditBusRoutes from "./components/Transport/EditBusRoutes";
import ManageRouteSections from "./components/Transport/ManageRouteSections";
import AddRouteSections from "./components/Transport/AddRouteSections";
import EditRouteSections from "./components/Transport/EditRouteSections";
import PrintBusRoutes from "./components/Transport/PrintBusRoutes";
import PrintRoutewiseStudentList from "./components/Transport/PrintRoutewiseStudentList";
import PrintRoutewiseAttendenceSheet from "./components/Transport/PrintRoutewiseAttendenceSheet";
import PrintBuswiseAttendenceSheet from "./components/Transport/PrintBuswiseAttendenceSheet";
import PrintBuswiseStudentList from "./components/Transport/PrintBuswiseStudentList";
import ImportFee from "./components/FeeSystem/ImportFee";
import RemarksConcessionReport from "./components/Reports/RemarksConcessionReport";
import RemarksConcessionPrint from "./components/Reports/RemarksConcessionPrint";
import RoutesReportDetails from "./components/Reports/RoutesReportDetails";
import PrintRoutesReportDetail from "./components/Reports/PrintRoutesReportDetail";
import ManageInvoice from "./components/Invoice/ManageInvoice";
import AddInvoice from "./components/Invoice/AddInvoice";
import InvoicePrint from "./components/Invoice/InvoicePrint";
import EditInvoicePayment from "./components/Invoice/EditInvoicePayment";
import ReceiveableFeeReport from "./components/Reports/ReceiveableFeeReport";
import HeadwieReceiveableFee from "./components/Reports/HeadwiseReceiveableFee";
import HeadwiseReceiveableFeePrint from "./components/Reports/HeadwiseReceiveableFeePrint";
import HeadwiseReceiveableFeePrintDetailed from "./components/Reports/HeadwiseReceiveableFeePrintDetailed";
import ReceiveableFeePrint from "./components/Reports/ReceiveableFeePrint";
import PromotionReport from "./components/Reports/PromotionReport";
import PromotionReportPrint from "./components/Reports/PromotionReportPrint";
import PayrollReport from "./components/PayRoll/PayrollReport";
import ManageEmployeeCampus from "./components/PayRoll/ManageEmployeeCampus";
import AddEmployeeCampus from "./components/PayRoll/AddEmployeeCampus";
import EditEmployeeCampus from "./components/PayRoll/EditEmployeeCampus";
import ImportEmployee from "./components/PayRoll/ImportEmployee";

// import ReturnReport from './components/Library/ReturnedReport';

function LegacyRoutesPrintRedirect() {
  const location = useLocation();
  return <Navigate to={`/Transport/RoutesPrint${location.search}`} replace />;
}

function legacyTransportPath(path) {
  return function LegacyTransportRedirect() {
    const location = useLocation();
    return <Navigate to={`/Transport/${path}${location.search}`} replace />;
  };
}

function LegacyEditBusRoutesRedirect() {
  const { id } = useParams();
  return <Navigate to={`/Transport/EditBusRoutes/${id}`} replace />;
}

function LegacyEditRouteSectionsRedirect() {
  const { id } = useParams();
  return <Navigate to={`/Transport/EditRouteSections/${id}`} replace />;
}

function LegacyEditVoucherRedirect() {
  const { id } = useParams();
  return <Navigate to={`/Accounts/ManageVouchers/edit/${id}`} replace />;
}

const LegacyAddVoucherRedirect = () => (
  <Navigate to="/Accounts/ManageVouchers/add" replace />
);

const LegacyPrintRoutewiseStudentListRedirect = legacyTransportPath("PrintRoutewise-StudentList");
const LegacyPrintBuswiseStudentListRedirect = legacyTransportPath("PrintBuswise-StudentList");
const LegacyPrintRoutewiseAttendenceSheetRedirect = legacyTransportPath("PrintRoutewise-AttendenceSheet");
const LegacyPrintBuswiseAttendenceSheetRedirect = legacyTransportPath("PrintBuswise-AttendenceSheet");
const LegacyPrintBusRoutesRedirect = legacyTransportPath("print/BusRoutes");

function Index() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Login />}></Route>
        <Route path="/" element={<Login />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/parent-login/children" element={<ParentSelectChildren />} />
        <Route path="/public/support" element={<PublicSupportTicket />} />

        <Route
          path="/Payroll/PrintSummarySheet"
          element={<PrintSummarySheet />}
        />
        <Route
          path="/Payroll/PrintDetailSummarySheet"
          element={<PrintDetailSummarySheet />}
        />
        <Route
          path="/Payroll/PrintSummarySheet2"
          element={<PrintSummarySheetTwo />}
        />
        <Route path="/Payroll/PrintZeroReport" element={<PrintZeroReport />} />
        <Route
          path="/Payroll/EmployeeReports/PrintEOBIList"
          element={<PrintEOBIList />}
        />
        <Route
          path="/Payroll/EmployeeReports/PrintPessiList"
          element={<PrintPessiList />}
        />
        <Route
          path="/Payroll/EmployeeReports/PrintTransportList"
          element={<PrintTransportList />}
        />
        <Route
          path="/PayRoll/EmployeeReports/PrintSWFList"
          element={<PrintSWFList />}
        />
        <Route
          path="/PayRoll/EmployeeReports/PrintTaxList"
          element={<PrintTaxList />}
        />
        <Route
          path="/PayRoll/EmployeeReports/PrintTaxList1"
          element={<PrintTaxList1 />}
        />
        <Route
          path="/PayRoll/EmployeeReports/PrintStaffList1"
          element={<PrintStaffList1 />}
        />
        <Route
          path="/PayRoll/EmployeeReports/PrintStaffList2"
          element={<PrintStaffList2 />}
        />
        <Route
          path="/PayRoll/EmployeeReports/PrintStaffList3"
          element={<PrintStaffList3 />}
        />
        <Route
          path="/PayRoll/EmployeeReports/PrintStaffList4"
          element={<PrintStaffList4 />}
        />
        <Route
          path="/PayRoll/OtherLoanDeductionsPrint"
          element={<OtherLoanDeductionsPrint />}
        />
        <Route
          path="/PayRoll/LoanDeductionsPrint"
          element={<LoanDeductionsPrint />}
        />
        <Route
          path="/PayRoll/PrintBankSalalryList"
          element={<PrintBankSalalryList />}
        />
        <Route
          path="/PayRoll/PrintManageLeaves"
          element={<PrintManageLeaves />}
        />
        <Route path="/Payroll/PaySlip/" element={<PaySlipPrint />}></Route>

        <Route
          path="/StockManagement/StockItemsPrint"
          element={<StockItemsPrint />}
        />
        <Route
          path="/StockManagement/PrintStockDetail"
          element={<PrintStockDetail />}
        ></Route>

        <Route
          path="/Students/PrintBiodataLists"
          element={<PrintBiodataLists />}
        />
        <Route
          path="/Students/PrintBiodataLists1"
          element={<PrintBiodataLists1 />}
        />
        <Route
          path="/students/PrintStudentProfile"
          element={<PrintStudentProfile />}
        />
        <Route
          path="/students/AdvanceSearch/print-advance-search"
          element={<PrintAdvaceSearchReport />}
        />
        <Route
          path="/students/PrintVoucher/"
          element={<PrintChallan />}
        ></Route>
        <Route
          path="/students/PrintVoucher"
          element={<PrintChallan />}
        ></Route>
        <Route
          path="/students/PublicChallanDownload/"
          element={<PublicChallanDownload />}
        ></Route>
        <Route
          path="/students/PrintVouchersWebsite/"
          element={<PrintVouchersWebsite />}
        ></Route>

        <Route
          path="/StaffAttendance/PrintMarkedAttendance"
          element={<PrintMarkedAttendance />}
        />
        <Route
          path="/StaffAttendance/PrintAttendanceSummary"
          element={<PrintAttendanceSummary />}
        ></Route>
        <Route
          path="/StaffAttendance/PrintReport"
          element={<PrintAttendanceReport />}
        ></Route>
        <Route
          path="/StaffAttendance/PrintLeaveRegister"
          element={<PrintLeaveRegister />}
        />

        <Route
          path="/Reports/UnpaidStudentPrint"
          element={<UnpaidStudentPrint />}
        />

        <Route path="/Reports/ConcessionPrint" element={<ConcessionPrint />} />
        <Route
          path="/Reports/RemarksConcessionPrint"
          element={<RemarksConcessionPrint />}
        />
        <Route path="/Transport/RoutesPrint" element={<RoutesPrint />} />
        <Route path="/Reports/RoutesPrint" element={<LegacyRoutesPrintRedirect />} />
        <Route
          path="/Reports/PrintRoutesReportDetail"
          element={<PrintRoutesReportDetail />}
        />
        <Route path="/Reports/StatusWisePrint" element={<StatusWisePrint />} />
        <Route
          path="/Reports/PrintStAttendanceSummary"
          element={<PrintStAttendanceSummary />}
        />
        <Route
          path="/Reports/StudentFinePrint"
          element={<StudentFinePrint />}
        />
        <Route
          path="/Reports/PrintNewAdmittedUnPaid"
          element={<PrintNewAdmittedUnPaid />}
        />
        <Route
          path="/Reports/PrintNewlyAdmittedStudents"
          element={<PrintNewlyAdmittedStudents />}
        />
        <Route
          path="/Reports/DefaultersListReport"
          element={<DefaultersListReport />}
        />
        <Route path="/Reports/StruckoffList" element={<StruckoffList />} />
        <Route
          path="/Reports/SectionWiseList/:id"
          element={<SectionWiseList />}
        ></Route>

        {/*Invoice*/}
        <Route
          path="/invoice/manage-invoice-print/:id"
          element={<InvoicePrint />}
        />

        {/* exams */}
        <Route
          path="/ExaminationSystem/ReportPrintExamDataSheet"
          element={<PrintExamDataSheet />}
        />
        <Route
          path="/ExaminationSystem/ReportPrintExamDataSheetMultiple"
          element={<PrintExamDataSheetMultiple />}
        />
        <Route
          path="/ExaminationSystem/PrintResultCards"
          element={<PrintResultCards />}
        />
        <Route
          path="/ExaminationSystem/PrintMasterSheet"
          element={<PrintMasterSheet />}
        />
        <Route
          path="/ExaminationSystem/PrintComponentMarksSheet"
          element={<PrintComponentMarksSheet />}
        />
        <Route
          path="/ExaminationSystem/PrintMarksCriteria"
          element={<PrintMarksCriteria />}
        />
        <Route
          path="/ExaminationSystem/PrintPublishedStudentResultCards"
          element={<PrintPublishedStudentResultCards />}
        />
        <Route
          path="/ExaminationSystem/PrintPublishedResultCardList"
          element={<PrintPublishedResultCardList />}
        />

        <Route
          path="/Students/PrintStudentLedger/:id"
          element={<PrintStudentLedger />}
        />
        <Route
          path="/FeeSystem/PrintCollectionReport"
          element={<PrintCollectionReport />}
        />
        <Route
          path="/FeeSystem/PrintCollectionReportDetail"
          element={<PrintCollectionReportDetail />}
        />

        <Route path="/Setup/BioDataForms" element={<BioDataForms />} />
        <Route
          path="/Setup/PrintStudentCards/:id"
          element={<PrintStudentCards />}
        />
        <Route
          path="/Setup/PrintAttendenceSheetClassWise/:id"
          element={<PrintAttendenceSheetClassWise />}
        />
        <Route
          path="/Transport/PrintRoutewise-StudentList"
          element={<PrintRoutewiseStudentList />}
        />
        <Route
          path="/Setup/PrintRoutewise-StudentList"
          element={<LegacyPrintRoutewiseStudentListRedirect />}
        />
        <Route
          path="/Transport/PrintBuswise-StudentList"
          element={<PrintBuswiseStudentList />}
        />
        <Route
          path="/Setup/PrintBuswise-StudentList"
          element={<LegacyPrintBuswiseStudentListRedirect />}
        />
        <Route
          path="/Transport/PrintRoutewise-AttendenceSheet"
          element={<PrintRoutewiseAttendenceSheet />}
        />
        <Route
          path="/Setup/PrintRoutewise-AttendenceSheet"
          element={<LegacyPrintRoutewiseAttendenceSheetRedirect />}
        />
        <Route
          path="/Transport/PrintBuswise-AttendenceSheet"
          element={<PrintBuswiseAttendenceSheet />}
        />
        <Route
          path="/Setup/PrintBuswise-AttendenceSheet"
          element={<LegacyPrintBuswiseAttendenceSheetRedirect />}
        />
        <Route
          path="/Setup/PrintConcessionRules"
          element={<PrintConcessionsRules />}
        />
        <Route
          path="/Setup/PrintConcessionStudents/:id"
          element={<PrintConcessionStudents />}
        />
        <Route
          path="/Setup/PrintManageClasses"
          element={<PrintManageClasses />}
        />
        <Route
          path="/Setup/PrintManageSections"
          element={<PrintManageSections />}
        />
        <Route path="/Setup/PrintFeeTypes" element={<PrintFeeTypeList />} />
        <Route path="/Setup/PrintManageWings" element={<PrintManageWings />} />
        <Route path="/Transport/print/BusRoutes" element={<PrintBusRoutes />} />
        <Route path="/Setup/print/BusRoutes" element={<LegacyPrintBusRoutesRedirect />} />
        <Route
          path="/Setup/PrintAttendenceSheet/:id"
          element={<PrintAttendenceSheet />}
        />
        <Route path="/Setup/Absenteelist/:id" element={<Absenteelist />} />
        <Route
          path="/Setup/PrintBioDataForms/:id"
          element={<PrintBioDataForms />}
        />
        <Route
          path="/Setup/PrintBioDataFormsforSection/:id"
          element={<PrintBioDataFormsforSection />}
        />
        <Route
          path="/Setup/PrintTestPerforma/:id"
          element={<PrintTestPerforma />}
        />
        <Route
          path="/Setup/OralAssessmentReport1/:id"
          element={<OralAssessmentReport1 />}
        />
        <Route
          path="/Setup/OralAssessmentReport2/:id"
          element={<OralAssessmentReport2 />}
        />

        <Route
          path="/Certificate/PrintStudentCertificates"
          element={<PrintStudentCertificates />}
        />
        <Route
          path="/MonthlyTasks/MonthDetails/PrintMonthDetails"
          element={<PrintMonthDetails />}
        />

        <Route
          path="/payroll/appointment-letter/print"
          element={<AppointmentLetterPrint />}
        />

        <Route path="/" element={<Main />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/invoice/manage-invoice" element={<ManageInvoice />} />
          <Route path="/invoice/add-invoice" element={<AddInvoice />} />
          <Route path="/invoice/edit-invoice/:id" element={<EditInvoicePayment />} />
          <Route path="/StudentForm" element={<StudentForm id="2" />} />

          <Route
            path="/students/StudentDashboard"
            element={<StudentDashboard />}
          />
          <Route path="/students/AddStudent" element={<AddStudent />} />
          <Route path="/students/ImportStudent" element={<ImportStudent />} />
          <Route path="/students/EditStudent/:id" element={<EditStudent />} />
          <Route
            path="/students/StudentHistory/:id"
            element={<StudentHistory />}
          />

          <Route path="/students/SearchStudents" element={<SearchStudents />} />
          <Route path="/students/AdmitStudent" element={<AdmitStudent />} />
          <Route path="/students/NewStudentList" element={<NewStudentList />} />
          <Route
            path="/students/ChangeRegistrationNo"
            element={<ChangeRegistrationNo />}
          />
          <Route path="/Students/AdvanceSearch" element={<AdvanceSearch />} />
          <Route
            path="/students/StudentNotifications"
            element={<StudentNotifications />}
          />
          <Route
            path="/events/SchoolEventsManagement"
            element={<SchoolEventsManagement />}
          />
          <Route
            path="/timetable/TimeTableManagement"
            element={<TimeTableManagement />}
          />
          <Route
            path="/timetable/coverage"
            element={<TimeTableCoverage />}
          />
          <Route
            path="/timetable/teacher-wise"
            element={<TimeTableTeacherWise />}
          />
          {/* <Route
            path="/Students/StudentLedger/:id"
            element={<StudentLedger />}
          /> */}
          <Route
            path="/Students/StudentLedger/:id"
            element={<StudentLedger2 />}
          />
          <Route path="/Students/BiodataLists" element={<BiodataLists />} />
          <Route path="/Students/StudentCard" element={<StudentCard />} />

          <Route
            path="/student/StudentProfileSearch"
            element={<StudentProfileSearch />}
          />

          <Route path="/support" element={<Navigate to="/support/raise-ticket" replace />} />
          <Route path="/support/raise-ticket" element={<NewTicket />} />
          <Route path="/support/open" element={<SupportOpen />} />
          <Route path="/support/inbox" element={<SupportInbox />} />
          <Route path="/support/tickets-close" element={<TicketsClose />} />
          <Route
            path="/support/ticket-detail/:id"
            element={<TicketsDetail />}
          />
          <Route
            path="/support/inbox-counter/:type"
            element={<InboxCounter />}
          />
          <Route path="/support/ticket-types" element={<ManageTicketTypes />} />
          <Route path="/support/add-ticket-type" element={<AddTicketType />} />
          <Route
            path="/support/edit-ticket-type/:id"
            element={<EditTicketType />}
          />

          <Route
            path="/AnnualTasks/AnnualTasksDashboard"
            element={<AnnualTasksDashboard />}
          />
          <Route path="/AnnualTasks/AddSessions" element={<AddSessions />} />
          <Route
            path="/AnnualTasks/ManageSessions"
            element={<ManageSessions />}
          />
          <Route
            path="/AnnualTasks/EditSession/:id"
            element={<EditSession />}
          />
          <Route
            path="/AnnualTasks/MarkAsStudyComplete"
            element={<MarkAsStudyComplete />}
          />
          <Route
            path="/AnnualTasks/PromoteClasses"
            element={<PromoteClasses />}
          />
          <Route
            path="/AnnualTasks/AddClassesInSessions"
            element={<AddClassesInSessions />}
          />

          <Route
            path="SMSAlert/SMSAlertDashboard"
            element={<SMSAlertDashboard />}
          />
          <Route
            path="SMSAlert/SendAlertToStaff"
            element={<SendAlertToStaff />}
          />
          <Route
            path="SMSAlert/SendtoSinglePerson"
            element={<SendtoSinglePerson />}
          />
          <Route
            path="SMSAlert/SendAlertToParents"
            element={<SendAlertToParents />}
          />

          <Route
            path="/Security/SecurityDashboard"
            element={<SecurityDashboard />}
          />
          <Route path="/Security/AddNewUser" element={<AddNewUser />} />
          <Route path="/Security/AddGroup" element={<AddGroup />} />
          <Route
            path="/Security/GroupManagement"
            element={<GroupManagement />}
          />
          <Route path="/Security/ManageUsers" element={<ManageUsers />} />
          <Route path="/Security/EditUser/:id" element={<EditUser />} />
          <Route path="/Security/EditGroup/:id" element={<EditGroup />} />
          <Route
            path="/Security/RightsAssignment/:id"
            element={<RightsAssignment />}
          />
          <Route path="/Security/ChangePassword" element={<ChangePassword />} />
          <Route path="/Setup/SetupDashboard" element={<SetupDashboard />} />
          <Route path="/no-access" element={<NoAccess />} />
          <Route
            path="/StaffAttendance/Report"
            element={<AttendanceReport />}
          />

          <Route path="/Setup/SchoolInfo" element={<SchoolInfo />} />
          <Route path="/Setup/ManageWings" element={<ManageWings />} />
          <Route path="/Setup/ManageClasses" element={<ManageClasses />} />
          <Route path="/Setup/ManageClassSyllabus" element={<ManageClassSyllabus />} />
          <Route path="/Setup/ClassSyllabusFiles/:classId" element={<ClassSyllabusFiles />} />
          <Route path="/Setup/ManageSection" element={<ManageSection />} />
          <Route path="/Setup/ManageFeeTypes" element={<ManageFeeTypes />} />
          <Route path="/Transport/TransportDashboard" element={<TransportDashboard />} />
          <Route path="/Transport/RoutesReport" element={<RoutesReport />} />
          <Route path="/Transport/ManageBusRoutes" element={<ManageBusRoutes />} />
          <Route path="/Setup/ManageBusRoutes" element={<Navigate to="/Transport/ManageBusRoutes" replace />} />
          <Route path="/Transport/ManageRouteSections" element={<ManageRouteSections />} />
          <Route path="/Setup/ManageRouteSections" element={<Navigate to="/Transport/ManageRouteSections" replace />} />
          <Route path="/Transport/AddBusRoutes" element={<AddBusRoutes />} />
          <Route path="/Setup/AddBusRoutes" element={<Navigate to="/Transport/AddBusRoutes" replace />} />
          <Route path="/Transport/AddRouteSections" element={<AddRouteSections />} />
          <Route path="/Setup/AddRouteSections" element={<Navigate to="/Transport/AddRouteSections" replace />} />
          <Route path="/Transport/EditBusRoutes/:id" element={<EditBusRoutes />} />
          <Route path="/Setup/EditBusRoutes/:id" element={<LegacyEditBusRoutesRedirect />} />
          <Route path="/Transport/EditRouteSections/:id" element={<EditRouteSections />} />
          <Route path="/Setup/EditRouteSections/:id" element={<LegacyEditRouteSectionsRedirect />} />
          <Route path="/Reports/RoutesReport" element={<Navigate to="/Transport/RoutesReport" replace />} />
          <Route
            path="/Setup/ManageConcession"
            element={<ManageConcession />}
          />
          <Route
            path="/Setup/EditRuleApplicable/:id"
            element={<EditRuleApplicable />}
          />
          <Route
            path="/Setup/ManageBankAccounts"
            element={<ManageBankAccounts />}
          />
          <Route path="/Setup/ManageSettings" element={<ManageSettings />} />
          <Route path="/Setup/ManageStudentHouses" element={<ManageStudentHouses />} />
          <Route path="/Setup/AddStudentHouse" element={<AddStudentHouse />} />
          <Route path="/Setup/EditStudentHouse/:id" element={<EditStudentHouse />} />
          <Route path="/Setup/AddWings" element={<AddWings />} />
          <Route path="/Setup/AddClass" element={<AddClass />} />
          <Route path="/Setup/EditClass/:id" element={<EditClass />} />

          <Route path="/Setup/AddFeeType" element={<AddFeeType />} />
          <Route path="/Setup/AddBankAcc" element={<AddBankAcc />} />
          <Route path="/Setup/AddSection" element={<AddSection />} />
          <Route path="/Setup/AddSetting" element={<AddSettings />} />
          <Route path="/Setup/UpdateSection/:id" element={<UpdateSection />} />
          <Route
            path="/Setup/ManageBankAccounts"
            element={<ManageBankAccounts />}
          />
          <Route path="/Setup/AddConcession" element={<AddConcession />} />
          <Route path="/Setup/Editfeetype/:id" element={<EditFeeType />} />
          <Route
            path="/Setup/EditConcession/:id"
            element={<EditConcession />}
          />
          <Route path="/Setup/EditBankAcc/:id" element={<EditBankAcc />} />
          <Route path="/Setup/EditSetting/:id" element={<EditSettings />} />

          <Route path="/Setup/EditWings/:id" element={<EditWings />} />

          <Route
            path="/Payroll/PayrollDashboard"
            element={<PayrollDashboard />}
          />
          <Route path="/Payroll/ManageEmployee" element={<ManageEmployee />} />
          <Route
            path="/Payroll/ManageDesignations"
            element={<ManageDesignations />}
          />
          <Route
            path="/Payroll/ManageEmployeeTypes"
            element={<ManageEmployeeTypes />}
          />
          <Route
            path="/Payroll/ManageEmployeeCampus"
            element={<ManageEmployeeCampus />}
          />
          <Route
            path="/Payroll/AddEmployeeType"
            element={<AddEmployeeType />}
          />
          <Route
            path="/Payroll/AddEmployeeCampus"
            element={<AddEmployeeCampus />}
          />
          <Route
            path="/Payroll/EditEmployeeType/:id"
            element={<EditEmployeeType />}
          />
          <Route
            path="/Payroll/EditEmployeeCampus/:id"
            element={<EditEmployeeCampus />}
          />
          <Route path="/Payroll/AddSalary" element={<AddSalary />} />
          <Route
            path="/Payroll/BankSalalryList"
            element={<BankSalalryList />}
          />
          <Route
            path="/Payroll/SalaryTypeValues/:id"
            element={<SalaryTypeValues />}
          />
          <Route path="/Payroll/CreateSalary" element={<CreateSalary />} />
          <Route
            path="/PayRoll/GenerateEmployeesSalary"
            element={<GenerateEmployeesSalary />}
          />
          <Route path="/PayRoll/BulkSalaryUpdate" element={<BulkSalaryUpdate />} />
          <Route
            path="/Payroll/ManageSalaryTypes"
            element={<ManageSalaryTypes />}
          />
          <Route
            path="/Payroll/IncreaseDecreaseSalary"
            element={<IncreaseDecreaseSalary />}
          />
          <Route path="/Payroll/AddSalaryType" element={<AddSalaryType />} />
          <Route
            path="/Payroll/EditSalaryType/:id"
            element={<EditSalaryType />}
          />
          <Route path="/Payroll/ManagePayRates" element={<ManagePayRates />} />
          <Route
            path="/Payroll/ManagePayRateDetails"
            element={<ManagePayRateDetails />}
          />
          <Route path="/Payroll/AddPayRate" element={<AddPayRate />} />
          <Route
            path="/Payroll/EditPayRate/:id"
            element={<EditPayRate />}
          />
          <Route
            path="/Payroll/ManageLoanDeduction"
            element={<ManageLoanDeduction />}
          />
          <Route
            path="/Payroll/AddLoanDeduction"
            element={<AddLoanDeduction />}
          />
          <Route
            path="/Payroll/EditLoanDeduction/:id"
            element={<EditLoanDeduction />}
          />
          <Route
            path="/Payroll/EditOtherLoanDeduction/:id"
            element={<EditOtherLoanDeduction />}
          />
          <Route
            path="/Payroll/AddOtherDeduction"
            element={<AddOtherDeduction />}
          />
          <Route
            path="/Payroll/ManageOtherLoanDeductions"
            element={<ManageOtherLoanDeductions />}
          />
          <Route
            path="/Payroll/EmployeeLedger/:id"
            element={<EmployeeLedger />}
          />
          <Route path="/Payroll/AddNewEmployee" element={<AddNewEmployee />} />
          <Route path="/Payroll/ImportEmployees" element={<ImportEmployee />} />
          <Route path="/Payroll/EditEmployee/:id" element={<EditEmployee />} />
          <Route path="/Payroll/EmployeeHistory/:id" element={<EmployeeHistory />} />
          <Route path="/Payroll/ManageSalary/:id" element={<ManageSalary />} />
          <Route path="/Payroll/PaySlips" element={<PaySlips />} />
          <Route
            path="/payroll/appointment-letter"
            element={<AppointmentLetter />}
          />
          <Route
            path="/Payroll/EmployeeReports"
            element={<EmployeeReports />}
          />
          <Route path="/Payroll/PayrollReport" element={<PayrollReport />} />
          <Route path="/Payroll/ZeroReports" element={<ZeroReports />} />
          <Route path="/Payroll/SummarySheet" element={<SummarySheet />} />
          <Route path="/Payroll/ChangeStatus/:id" element={<ChangeStatus />} />
          <Route path="/Payroll/ManageLeaves" element={<ManageLeaves />} />
          <Route path="/Payroll/AddArrear" element={<AddArrear />} />
          <Route path="/PayRoll/AddLeave/:id" element={<AddLeave />} />

          <Route
            path="/Payroll/EditDesignation/:id"
            element={<EditDesignation />}
          />
          <Route
            path="/Payroll/AddNewDesignation"
            element={<AddNewDesignation />}
          />

          <Route
            path="/Library/LibraryDashboard"
            element={<LibraryDashboard />}
          />
          <Route path="/Library/AddBook" element={<AddBook />} />
          <Route path="/Library/EditBook/:id" element={<EditBook />} />
          <Route path="/Library/IssueBook/:id" element={<IssueBook />} />
          <Route path="/Library/ViewLibrary" element={<ViewLibrary />} />
          <Route path="/Library/IssuanceReport" element={<IssuanceReport />} />
          <Route path="/Library/ReturnReport" element={<ReturnReport />} />
          <Route path="/Library/OverdueReport" element={<OverdueReport />} />
          <Route path="/Library/BorrowHistory" element={<BorrowHistory />} />
          <Route path="/Library/ImportBooks" element={<ImportBooks />} />

          <Route
            path="/FeeSystem/FeeSystemDashboard"
            element={<FeeSystemDashboard />}
          />
          <Route
            path="/FeeSystem/ScrollDifferenceDetail/:studentId"
            element={<ScrollDifferenceDetail />}
          />
          <Route path="/FeeSystem/PrintVouchers" element={<PrintVouchers />} />
          <Route
            path="/FeeSystem/StudentsMissingVoucher"
            element={<StudentsMissingVoucher />}
          />
          <Route path="/FeeSystem/DeletedVouchers" element={<DeletedVouchers />} />
          <Route path="/FeeSystem/EditChallan" element={<EditChallan />} />
          <Route path="/FeeSystem/AdminEditChallan" element={<AdminEditChallan />} />
          <Route path="/FeeSystem/GenerateChallan" element={<GenerateChallan />} />
          <Route path="/FeeSystem/GenerateAdvanceChallan" element={<GenerateAdvanceChallan />} />
          <Route path="/FeeSystem/DuplicatePaymentReceived" element={<DuplicatePaymentReceived />} />
          <Route path="/FeeSystem/ChallanCorrector" element={<ChallanCorrector />} />
          <Route
            path="/FeeSystem/PrintAllVouchers"
            element={<PrintAllVouchers />}
          />
          <Route path="/FeeSystem/AddBankScroll" element={<AddBankScroll />} />
          <Route path="/FeeSystem/ChangeScrollDate" element={<ChangeScrollDate />} />
          <Route
            path="/FeeSystem/CollectionReport"
            element={<CollectionReport />}
          />
          <Route
            path="/FeeSystem/CollectionReportHeadWise"
            element={<CollectionReportHeadWise />}
          />
          <Route
            path="/FeeSystem/DateWiseCollectionReport"
            element={<DateWiseCollectionReport />}
          />
          <Route path="/FeeSystem/AdvanceAmountReport" element={<AdvanceAmountReport />} />
          <Route path="/FeeSystem/AdvanceAdjustedInMonthReport" element={<AdvanceAdjustedInMonthReport />} />
          <Route path="/FeeSystem/AddAbsentFine" element={<AddAbsentFine />} />
          <Route
            path="/FeeSystem/AddOtherDuesFine"
            element={<AddOtherDuesFine />}
          />
          <Route path="/FeeSystem/ImportFee" element={<ImportFee />} />
          <Route
            path="/FeeSystem/ChangeStudentStatus"
            element={<ChangeStudentStatus />}
          />

          <Route
            path="/Reports/ReportsDashboard"
            element={<ReportDashboard />}
          />
          <Route
            path="/Reports/AccountHeadwiseReport"
            element={<AccountHeadwiseReport />}
          />

          <Route
            path="/Reports/ConcessionReport"
            element={<ConcessionReport />}
          />
          <Route
            path="/Reports/RemarksConcessionReport"
            element={<RemarksConcessionReport />}
          />

          <Route
            path="/Reports/RoutesReportDetails/:routeCode"
            element={<RoutesReportDetails />}
          />
          <Route path="/Reports/DefaultersList" element={<DefaultersList />} />
          <Route
            path="/Reports/FeeCollectionDetail"
            element={<FeeCollectionDetail />}
          />
          <Route path="/Reports/FeeReporting" element={<FeeReporting />} />
          <Route
            path="/Reports/ReceiveableFeeReport"
            element={<ReceiveableFeeReport />}
          />
          <Route
            path="/Reports/HeadwiseReceiveableFee"
            element={<HeadwieReceiveableFee />}
          />
          <Route
            path="/Reports/FeePostingIssues"
            element={<FeePostingIssues />}
          />
          <Route
            path="/Reports/NewAdmittedUnPaid"
            element={<NewAdmittedUnPaid />}
          />
          <Route
            path="/Reports/StatusWiseChange"
            element={<StatusWiseChange />}
          />
          <Route
            path="/Reports/StruckedStudents"
            element={<StruckedStudents />}
          />
          <Route
            path="/Reports/StudentFineReport"
            element={<StudentFineReport />}
          />
          <Route
            path="/Reports/PromotionReport"
            element={<PromotionReport />}
          />
          <Route
            path="/Reports/StudentStrengthReport"
            element={<StudentStrengthReport />}
          />
          <Route path="/Reports/UnpaidStudent" element={<UnpaidStudent />} />
          <Route
            path="/Reports/NewlyAdmittedStudents"
            element={<NewlyAdmittedStudents />}
          />
          <Route
            path="/Reports/AttendenceSummary"
            element={<AttendenceSummary />}
          />
          <Route
            path="/Reports/StAttendenceSummary"
            element={<StAttendenceSummary />}
          />
          <Route path="/Reports/ReportsMenu" element={<ReportsMenu />}></Route>

          <Route
            path="/MonthlyTasks/MonthlyTasksDashboard"
            element={<MonthlyTasksDashboard />}
          />
          <Route path="/MonthlyTasks/ManageMonth" element={<ManageMonth />} />
          <Route
            path="/MonthlyTasks/ManageVouchers"
            element={<ManageMonthlyVouchers />}
          />
          <Route path="/MonthlyTasks/MonthDetails" element={<MonthDetails />} />
          <Route
            path="/MonthlyTasks/StartNewMonth"
            element={<StartNewMonth2 />}
          />
          {/* <Route path="/MonthlyTasks/StartNewMonth" element={<StartNewMonth />} /> */}

          <Route
            path="/Accounts/AccountsDashboard"
            element={<AccountsDashboard />}
          />
          <Route path="/Accounts/ManageAccounts" element={<ManageAccount />} />
          <Route path="/Accounts/ChangeYear" element={<ChangeYear />} />
          <Route path="/Accounts/AddNewAccount" element={<AddNewAccount />} />
          <Route path="/Accounts/ManageVouchers/edit/:id" element={<EditVoucher />} />
          <Route path="/Accounts/ManageVouchers/add" element={<AddVoucher />} />
          <Route path="/Accounts/ManageVouchers" element={<ManageVouchers />} />
          <Route path="/Accounts/EditVoucher/:id" element={<LegacyEditVoucherRedirect />} />
          <Route path="/Accounts/AddVoucher" element={<LegacyAddVoucherRedirect />} />
          <Route
            path="/Accounts/OpeningBalances"
            element={<OpeningBalances />}
          />
          <Route
            path="/Accounts/ManageOpeningBalances"
            element={<ManageOpeningBalances />}
          />
          <Route
            path="/Accounts/GeneralLedger/:accountcode"
            element={<GeneralLedger />}
          />
          <Route
            path="/Accounts/TrialBalanceLevelWise"
            element={<TrialBalanceLevelWise />}
          />
          <Route
            path="/Accounts/TrialBalanceHeadWise"
            element={<TrialBalanceHeadWise />}
          />
          <Route
            path="/Accounts/IncomeExpenditure"
            element={<IncomeExpenditure />}
          />
          <Route path="/Accounts/BudgetHeadWise" element={<BudgetHeadWise />} />
          <Route
            path="/Accounts/PrintBudgetHeadWise"
            element={<PrintBudgetHeadWise />}
          />
          <Route
            path="/Accounts/PrintReceiptPayment"
            element={<PrintReceiptPayment />}
          />
          <Route
            path="/Accounts/EditOpeningBalance/:id"
            element={<EditOpeningBalance />}
          />
          <Route path="/Accounts/ReceiptPayment" element={<ReceiptPayment />} />

          <Route
            path="/Certificate/CertificateDashboard"
            element={<CertificateDashboard />}
          />
          <Route
            path="/Certificate/PrintCertificates"
            element={<PrintCertificates />}
          />

          <Route
            path="/ExaminationSystem/ExaminationDashboard"
            element={<ExaminationDashboard />}
          />
          <Route
            path="/ExaminationSystem/AddExaminations"
            element={<AddExaminations />}
          />
          <Route
            path="/ExaminationSystem/AddSubjectType"
            element={<AddSubjectType />}
          />
          <Route
            path="/ExaminationSystem/AddSubject"
            element={<AddSubject />}
          />
          <Route path="/ExaminationSystem/CloseExam" element={<CloseExam />} />
          <Route path="/ExaminationSystem/DataEntry" element={<DataEntry />} />
          <Route
            path="/ExaminationSystem/ExamDataEntryOptions/:id"
            element={<ExamDataEntryOptions />}
          />
          <Route
            path="/ExaminationSystem/ExamDataSheetOptions"
            element={<ExamDataSheetOptions />}
          />
          <Route
            path="/ExaminationSystem/ManageClassSubjects"
            element={<ManageClassSubjects />}
          />
          <Route
            path="/ExaminationSystem/ManageExamClasses"
            element={<ManageExamClasses />}
          />
          <Route
            path="/ExaminationSystem/ManageExaminations"
            element={<ManageExaminations />}
          />
          <Route
            path="/ExaminationSystem/ManageSubjects"
            element={<ManageSubjects />}
          />
          <Route
            path="/ExaminationSystem/ManageSubjectTypes"
            element={<ManageSubjectTypes />}
          />
          <Route
            path="/ExaminationSystem/OldResults"
            element={<OldResults />}
          />
          <Route
            path="/ExaminationSystem/EditSubjectType/:id"
            element={<EditSubjectType />}
          />
          <Route
            path="/ExaminationSystem/EditSubject/:id"
            element={<EditSubject />}
          />
          <Route
            path="/ExaminationSystem/EditExam/:id"
            element={<EditExam />}
          />
          <Route
            path="/ExaminationSystem/ExamClasses/:id"
            element={<ExamClasses />}
          />
          <Route
            path="/ExaminationSystem/ExamDataSO"
            element={<ExamDataSO />}
          />
          <Route
            path="/ExaminationSystem/CloseThisExam"
            element={<CloseThisExam />}
          />
          <Route
            path="/ExaminationSystem/ManageResultCards"
            element={<ManageResultCards />}
          />
          <Route
            path="/ExaminationSystem/AddResultCard"
            element={<AddResultCard />}
          />
          <Route
            path="/ExaminationSystem/EditResultCard/:id"
            element={<EditResultCard />}
          />
          <Route
            path="/ExaminationSystem/PublishResultCard"
            element={<PublishResultCard />}
          />
          <Route
            path="/ExaminationSystem/PrintPublishedResultCard"
            element={<PrintPublishedResultCard />}
          />
          <Route
            path="/ExaminationSystem/ExaminationGuidelines"
            element={<ExaminationGuidelines />}
          />

          <Route
            path="/StockManagement/StocksDashboard"
            element={<StocksDashboard />}
          />
          <Route
            path="/StockManagement/AddStockCategory"
            element={<AddStockCategory />}
          />
          <Route
            path="/StockManagement/IssueItems/:id"
            element={<IssueItems />}
          />
          <Route
            path="/StockManagement/ManageStockCategory"
            element={<ManageStockCategory />}
          />
          <Route
            path="/StockManagement/StockDetail/:id"
            element={<StockDetail />}
          />
          <Route
            path="/StockManagement/EditStockItems/:id"
            element={<EditStockItems />}
          />

          <Route
            path="/StaffAttendance/StaffAttendanceDashboard"
            element={<StaffAttendanceDashboard />}
          />
          <Route
            path="/StaffAttendance/MarkAttendance"
            element={<MarkAttendance />}
          />
          <Route
            path="/StaffAttendance/AttendanceSummary"
            element={<AttendanceSummary />}
          />
          <Route
            path="/StaffAttendance/LeaveRegister"
            element={<LeaveRegister />}
          />
          <Route
            path="/StaffAttendance/AttendanceRights"
            element={<AttendanceRights />}
          />

          <Route
            path="/StudentAttendance/StudentAttendanceDashboard"
            element={<StudentAttendanceDashboard />}
          />
          <Route
            path="/StudentAttendance/MarkSTAttendance"
            element={<MarkSTAttendance />}
          />
          <Route
            path="/StudentAttendance/AttendanceSTSummary"
            element={<AttendanceSTSummary />}
          />
        </Route>

        <Route
          path="/StockManagement/PrintStockDetail"
          element={<PrintStockDetail />}
        ></Route>

        <Route
          path="/Accounts/PrintOpeningBalance"
          element={<PrintOpeningBalance />}
        />
        <Route
          path="/Accounts/PrintManageAccount"
          element={<PrintManageAccount />}
        />
        <Route
          path="/Accounts/PrintTrialBalanceLevelWise"
          element={<PrintTrialBalanceLevelWise />}
        />
        <Route
          path="/Accounts/PrintTrialBalanceHeadWise"
          element={<PrintTrialBalanceHeadWise />}
        />
        <Route
          path="/Accounts/PrintIncomeExpenditure"
          element={<PrintIncomeExpenditure />}
        />
        <Route
          path="/Accounts/PrintGeneralLedger"
          element={<PrintGeneralLedger />}
        />

        <Route
          path="/ExaminationSystem/PrintExamDataSheet"
          element={<PrintExamDataEntryOptions />}
        />
        <Route
          path="/PrintReports/SectionWiseClassList/:id"
          element={<SectionWiseClassList />}
        ></Route>
        <Route
          path="/PrintReports/Classwiseattendancesheet/:id"
          element={<Classwiseattendancesheet />}
        ></Route>
        <Route
          path="/PrintReports/AbsentListClassWise/:id"
          element={<AbsentListClassWise />}
        ></Route>
        <Route
          path="/PrintReports/PrintBioDataFormsList/:id"
          element={<PrintBioDataFormsList />}
        ></Route>
        <Route
          path="/PrintReports/PrintStudentCardsList/:id"
          element={<PrintStudentCardsList />}
        ></Route>
        <Route
          path="/PrintReports/PrintTestPerformaList/:id"
          element={<PrintTestPerformaList />}
        ></Route>
        <Route
          path="/PrintReports/RPTAwardListClass/:id"
          element={<RPTAwardListClass />}
        ></Route>
        <Route
          path="/PrintReports/PrintOralAssessmentReport1/:id"
          element={<PrintOralAssessmentReport1 />}
        ></Route>
        <Route
          path="/PrintReports/PrintOralAssessmentReport1Urdu/:id"
          element={<PrintOralAssessmentReport1Urdu />}
        ></Route>
        <Route
          path="/PrintReports/PrintOralAssessmentReport2Urdu/:id"
          element={<PrintOralAssessmentReport2Urdu />}
        ></Route>

        <Route
          path="/Library/PrintIssuanceReport"
          element={<PrintIssuanceReport />}
        />
        <Route
          path="/Library/PrintReturnReport"
          element={<PrintReturnReport />}
        />
        <Route
          path="/Library/PrintViewLibrary"
          element={<PrintViewLibrary />}
        />

        <Route
          path="/PrintReports/RPTAwardList/:id"
          element={<RPTAwardList />}
        ></Route>

        <Route
          path="/Reports/FeeReportingPrint"
          element={<FeeReportingPrint />}
        ></Route>
        <Route
          path="/Reports/PromotionReportPrint"
          element={<PromotionReportPrint />}
        ></Route>
        <Route
          path="/Reports/HeadwiseReceiveableFeePrint"
          element={<HeadwiseReceiveableFeePrint />}
        ></Route>
        <Route
          path="/Reports/HeadwiseReceiveableFeePrintDetailed"
          element={<HeadwiseReceiveableFeePrintDetailed />}
        ></Route>
        <Route
          path="/Reports/ReceiveableFeePrint"
          element={<ReceiveableFeePrint />}
        ></Route>

        <Route
          path="/Reports/PrintStudentStrengthReports"
          element={<PrintStudentStrengthReports />}
        ></Route>

        <Route
          path="/Security/PrintManageUser"
          element={<PrintManageUser />}
        ></Route>
        <Route
          path="/setup/editruleapplicable-print"
          element={<PrintRuleApplicable />}
        ></Route>

        <Route path="/teacher" element={<TeacherMain />}>
          <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
          <Route
            path="/teacher/change-password"
            element={<Change_Password />}
          />
          <Route path="/teacher/update-photo" element={<UpdatePhoto />} />
          <Route
            path="/teacher/section-incharge"
            element={<Section_Incharge />}
          />
          <Route
            path="/teacher/subject-teacher"
            element={<Subject_Teacher />}
          />
          <Route path="/teacher/manage-sections" element={<ManageSections />} />
          <Route path="/teacher/wing-sections" element={<WingHeadManageSections />} />
          <Route path="/teacher/wing-section/:id" element={<TeacherWingSectionSettings />} />
          <Route
            path="/teacher/MarkStudentAttendance"
            element={<MarkStudentAttendance />}
          />
          <Route path="/teacher/atsummary" element={<ATSummary />} />
          <Route path="/teacher/UpdateProfile" element={<UpdateProfile />} />
          <Route path="/teacher/ViewPaySlips" element={<ViewPaySlips />} />
          <Route path="/teacher/events" element={<TeacherEvents />} />
          <Route path="/teacher/diary" element={<TeacherDiaryManager />} />
          <Route path="/teacher/timetable" element={<TeacherTimeTable />} />
        </Route>

        <Route path="/student-panel" element={<StudentMain />}>
          <Route
            path="/student-panel/dashboard"
            element={<StudentPanelDashboard />}
          />
          <Route
            path="/student-panel/change-password"
            element={<Student_Change_Password />}
          />
          <Route
            path="/student-panel/parent-change-password"
            element={<Parent_Change_Password />}
          />
          <Route
            path="/student-panel/update-photo"
            element={<StudentUpdatePhoto />}
          />
          <Route
            path="/student-panel/update-profile"
            element={<StudentUpdateProfile />}
          />
          <Route
            path="/student-panel/student-ledger"
            element={<StudentPanelLedger />}
          />
          <Route
            path="/student-panel/student-summary"
            element={<SingleStudentSummary />}
          />
          <Route
            path="/student-panel/library-books"
            element={<StudentPanelLibrary />}
          />
          <Route
            path="/student-panel/exam-results"
            element={<ExamResultsComingSoon />}
          />
          <Route
            path="/student-panel/view-siblings"
            element={<ViewSiblings />}
          />
          <Route
            path="/student-panel/transport"
            element={<StudentPanelTransport />}
          />
          <Route
            path="/student-panel/alerts-updates"
            element={<StudentPanelAlerts />}
          />
          <Route
            path="/student-panel/events-calendar"
            element={<StudentPanelEvents />}
          />
          <Route
            path="/student-panel/class-timetable"
            element={<StudentPanelClassTimeTable />}
          />
          <Route
            path="/student-panel/module/syllabus-download"
            element={<StudentPanelSyllabusDownload />}
          />
          <Route
            path="/student-panel/module/students-diary"
            element={<StudentPanelDiary />}
          />
          <Route
            path="/student-panel/module/events-calendar"
            element={<Navigate to="/student-panel/events-calendar" replace />}
          />
          <Route
            path="/student-panel/module/alerts-updates"
            element={<Navigate to="/student-panel/alerts-updates" replace />}
          />
          <Route
            path="/student-panel/module/complaints-management"
            element={<Navigate to="/student-panel/support/tickets" replace />}
          />
          <Route
            path="/student-panel/module/:moduleSlug"
            element={<StudentPanelModuleComingSoon />}
          />
          <Route
            path="/student-panel/support/tickets"
            element={<StudentSupportTickets />}
          />
          <Route
            path="/student-panel/support/tickets/:id"
            element={<StudentSupportTicketDetail />}
          />
          <Route
            path="/student-panel/support/raise"
            element={<StudentSupportNewTicket />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Index />);
